import React, { useCallback, useEffect, ReactNode, FC, useMemo, useRef } from "react";
import { ExportProvider, FavouriteProvider, SubscriptionProvider } from "./shared";
import { Middleware, MiddlewareSync } from "@sa/rep-common";
import { DataFlowProcessingState, ComponentContextProcessingState, IComponentContext } from "@sa/rep-core";
import { ComponentProcessingState, ReportingProvider, ReportProvider } from "@sa/rep-react";
import { reportService, serviceProvider } from "./dataFlow";
import ExampleReport from "./reports/Example";
import Report13 from "./reports/Report13";
import Report12 from "./reports/Report12";
import Report11 from "./reports/Report11";
import Report10 from "./reports/Report10";
import Report9 from "./reports/Report9";
import AquariumCropValue from "./reports/AquariumCropValue";
import Report8 from "./reports/Report8";
import Report7 from "./reports/Report7";
import Report6 from "./reports/Report6";
import Report5 from "./reports/Report5";
import Report4 from "./reports/Report4";
import Report3 from "./reports/Report3";
import Report2 from "./reports/Report2";
import Report1 from "./reports/Report1";
import { exampleComponentMiddleware, exampleContextsMiddleware, exampleDataflowMiddlewares } from "./reports/Example/middlewares";
import { report1ComponentMiddleware, report1ContextsMiddleware, report1DataflowMiddlewares } from "./reports/Report1/middlewares";
import { report2ComponentMiddleware, report2ContextsMiddleware, report2DataflowMiddlewares } from "./reports/Report2/middlewares";
import { report3ComponentMiddleware, report3ContextsMiddleware, report3DataflowMiddlewares } from "./reports/Report3/middlewares";
import { report4ComponentMiddleware, report4ContextsMiddleware, report4DataflowMiddlewares } from "./reports/Report4/middlewares";
import { report5ComponentMiddleware, report5ContextsMiddleware, report5DataflowMiddlewares } from "./reports/Report5/middlewares";
import { report6ComponentMiddleware, report6ContextsMiddleware, report6DataflowMiddlewares } from "./reports/Report6/middlewares";
import { report7ComponentMiddleware, report7ContextsMiddleware, report7DataflowMiddlewares } from "./reports/Report7/middlewares";
import { report8ComponentMiddleware, report8ContextsMiddleware, report8DataflowMiddlewares } from "./reports/Report8/middlewares";
import {
  aquariumCropValueComponentMiddleware,
  aquariumCropValueContextsMiddleware,
  aquariumCropValueDataflowMiddlewares,
} from "./reports/AquariumCropValue/middlewares";
import { report9ComponentMiddleware, report9ContextsMiddleware, report9DataflowMiddlewares } from "./reports/Report9/middlewares";
import { report10ComponentMiddleware, report10ContextsMiddleware, report10DataflowMiddlewares } from "./reports/Report10/middlewares";
import { report11ComponentMiddleware, report11ContextsMiddleware, report11DataflowMiddlewares } from "./reports/Report11/middlewares";
import { report12ComponentMiddleware, report12ContextsMiddleware, report12DataflowMiddlewares } from "./reports/Report12/middlewares";
import { report13ComponentMiddleware, report13ContextsMiddleware, report13DataflowMiddlewares } from "./reports/Report13/middlewares";
import { slide12ComponentMiddleware, slide12ContextsMiddleware, slide12DataflowMiddlewares } from "./reports/Slide12/middlewares";
import { slide13ComponentMiddleware, slide13ContextsMiddleware, slide13DataflowMiddlewares } from "./reports/Slide13/middlewares";
import { slide15ComponentMiddleware, slide15ContextsMiddleware, slide15DataflowMiddlewares } from "./reports/Slide15/middlewares";
import { slide16ComponentMiddleware, slide16ContextsMiddleware, slide16DataflowMiddlewares } from "./reports/Slide16/middlewares";
import { slide17ComponentMiddleware, slide17ContextsMiddleware, slide17DataflowMiddlewares } from "./reports/Slide17/middlewares";
import { slide18ComponentMiddleware, slide18ContextsMiddleware, slide18DataflowMiddlewares } from "./reports/Slide18/middlewares";
import { slide20ComponentMiddleware, slide20ContextsMiddleware, slide20DataflowMiddlewares } from "./reports/Slide20/middlewares";
import { slide21ComponentMiddleware, slide21ContextsMiddleware, slide21DataflowMiddlewares } from "./reports/Slide21/middlewares";
import { slide23ComponentMiddleware, slide23ContextsMiddleware, slide23DataflowMiddlewares } from "./reports/Slide23/middlewares";
import { slide24ComponentMiddleware, slide24ContextsMiddleware, slide24DataflowMiddlewares } from "./reports/Slide24/middlewares";
import { slide31ComponentMiddleware, slide31ContextsMiddleware, slide31DataflowMiddlewares } from "./reports/Slide31/middlewares";
import { slide32ComponentMiddleware, slide32ContextsMiddleware, slide32DataflowMiddlewares } from "./reports/Slide32/middlewares";
import { slide33ComponentMiddleware, slide33ContextsMiddleware, slide33DataflowMiddlewares } from "./reports/Slide33/middlewares";
import { slide34ComponentMiddleware, slide34ContextsMiddleware, slide34DataflowMiddlewares } from "./reports/Slide34/middlewares";
import { slide35ComponentMiddleware, slide35ContextsMiddleware, slide35DataflowMiddlewares } from "./reports/Slide35/middlewares";
import { slide36ComponentMiddleware, slide36ContextsMiddleware, slide36DataflowMiddlewares } from "./reports/Slide36/middlewares";
import { HightChartsThemeContext, defaultContext } from "../charts/components/HighchartsReact";
import { SlidePayload } from "../subscriptions/types";

// Создаём pipeline для обработки изменения параметров отчётов
const dataflowMiddlewares: Middleware<DataFlowProcessingState>[] = [
  exampleDataflowMiddlewares,
  report1DataflowMiddlewares(serviceProvider),
  report2DataflowMiddlewares(serviceProvider),
  report3DataflowMiddlewares(serviceProvider),
  report4DataflowMiddlewares(serviceProvider),
  report5DataflowMiddlewares(serviceProvider),
  report6DataflowMiddlewares(serviceProvider),
  report7DataflowMiddlewares(serviceProvider),
  report8DataflowMiddlewares(serviceProvider),
  aquariumCropValueDataflowMiddlewares(serviceProvider),
  slide12DataflowMiddlewares(serviceProvider),
  slide13DataflowMiddlewares(serviceProvider),
  slide15DataflowMiddlewares(serviceProvider),
  slide16DataflowMiddlewares(serviceProvider),
  slide17DataflowMiddlewares(serviceProvider),
  slide18DataflowMiddlewares(serviceProvider),
  slide20DataflowMiddlewares(serviceProvider),
  slide21DataflowMiddlewares(serviceProvider),
  slide23DataflowMiddlewares(serviceProvider),
  slide24DataflowMiddlewares(serviceProvider),
  slide31DataflowMiddlewares(serviceProvider),
  slide32DataflowMiddlewares(serviceProvider),
  slide33DataflowMiddlewares(serviceProvider),
  slide34DataflowMiddlewares(serviceProvider),
  slide35DataflowMiddlewares(serviceProvider),
  slide36DataflowMiddlewares(serviceProvider),
  report9DataflowMiddlewares,
  report10DataflowMiddlewares,
  report11DataflowMiddlewares(serviceProvider),
  report12DataflowMiddlewares(serviceProvider),
  report13DataflowMiddlewares,
];

// Создаём pipeline для инстанцирования контекстов компонентов
const componentContextsMiddlewares: MiddlewareSync<ComponentContextProcessingState>[] = [
  exampleContextsMiddleware,
  report1ContextsMiddleware,
  report2ContextsMiddleware,
  report3ContextsMiddleware,
  report4ContextsMiddleware,
  report5ContextsMiddleware,
  report6ContextsMiddleware,
  report7ContextsMiddleware,
  report8ContextsMiddleware,
  aquariumCropValueContextsMiddleware,
  report9ContextsMiddleware,
  report10ContextsMiddleware,
  report11ContextsMiddleware,
  report12ContextsMiddleware,
  report13ContextsMiddleware,
  slide12ContextsMiddleware,
  slide13ContextsMiddleware,
  slide15ContextsMiddleware,
  slide16ContextsMiddleware,
  slide17ContextsMiddleware,
  slide18ContextsMiddleware,
  slide20ContextsMiddleware,
  slide21ContextsMiddleware,
  slide23ContextsMiddleware,
  slide24ContextsMiddleware,
  slide31ContextsMiddleware,
  slide32ContextsMiddleware,
  slide33ContextsMiddleware,
  slide34ContextsMiddleware,
  slide35ContextsMiddleware,
  slide36ContextsMiddleware,
];

const componentsMiddlewares: MiddlewareSync<ComponentProcessingState>[] = [
  exampleComponentMiddleware,
  report1ComponentMiddleware,
  report2ComponentMiddleware,
  report3ComponentMiddleware,
  report4ComponentMiddleware,
  report5ComponentMiddleware,
  report6ComponentMiddleware,
  report7ComponentMiddleware,
  report8ComponentMiddleware,
  aquariumCropValueComponentMiddleware,
  report9ComponentMiddleware,
  report10ComponentMiddleware,
  report11ComponentMiddleware,
  report12ComponentMiddleware,
  report13ComponentMiddleware,
  slide12ComponentMiddleware,
  slide13ComponentMiddleware,
  slide15ComponentMiddleware,
  slide16ComponentMiddleware,
  slide17ComponentMiddleware,
  slide18ComponentMiddleware,
  slide20ComponentMiddleware,
  slide21ComponentMiddleware,
  slide23ComponentMiddleware,
  slide24ComponentMiddleware,
  slide31ComponentMiddleware,
  slide32ComponentMiddleware,
  slide33ComponentMiddleware,
  slide34ComponentMiddleware,
  slide35ComponentMiddleware,
  slide36ComponentMiddleware,
];

interface IReportsProvider {
  children: ReactNode;
  reportId: string;
  applySavedFavouriteByDefault?: boolean;
  subscriptionPayload?: SlidePayload;
}
const ReportsProvider: FC<IReportsProvider> = ({ children, reportId, applySavedFavouriteByDefault, subscriptionPayload }) => {
  const { current: store } = useRef(new Map<string, IComponentContext>());

  useEffect(() => {
    return () => {
      store.clear();
    };
  }, []);

  const checkStoreContextsMiddleware: MiddlewareSync<ComponentContextProcessingState> = useCallback((input, next) => {
    const candidateContext = store.get(input.identification.reportId);
    if (candidateContext) {
      input.componentContext = candidateContext;
      return input;
    }
    return next(input);
  }, []);

  const fillStoreContextsMiddleware: MiddlewareSync<ComponentContextProcessingState> = useCallback((input, next) => {
    if (!store.has(input.identification.reportId) && input.componentContext) {
      store.set(input.identification.reportId, input.componentContext);
    }
    return input;
  }, []);

  const reportingProviderProps = useMemo(
    () => ({
      reportDefinitionsService: reportService,
      serviceProvider,
      dataflowMiddlewares,
      componentContextsMiddlewares: [checkStoreContextsMiddleware, ...componentContextsMiddlewares, fillStoreContextsMiddleware],
      componentsMiddlewares: componentsMiddlewares,
    }),
    [checkStoreContextsMiddleware, fillStoreContextsMiddleware]
  );

  return (
    <ReportingProvider {...reportingProviderProps}>
      <ReportProvider id={reportId}>
        <ExportProvider triggerValues={[reportId]}>
          <SubscriptionProvider reportId={reportId} payload={subscriptionPayload}>
            <FavouriteProvider reportId={reportId} applySavedFavouriteByDefault={applySavedFavouriteByDefault}>
              <HightChartsThemeContext.Provider value={defaultContext}>{children}</HightChartsThemeContext.Provider>
            </FavouriteProvider>
          </SubscriptionProvider>
        </ExportProvider>
      </ReportProvider>
    </ReportingProvider>
  );
};

export default ReportsProvider;
